import './switch.less';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';

const propTypes = { intl: PropTypes.func };

const Switch = ({intl}) => (
	<div className="payout-log__switch-control">
		<Link
			to={'payout-log/transfers'}
			activeClassName={'active'}>
			<span className="icon" />
			<span>{intl('Transfers')}</span>
		</Link>

		<Link
			to={'payout-log/payments'}
			activeClassName={'active'}>
			<span className="icon" />
			<span>{intl('Payments')}</span>
		</Link>
	</div>
);

Switch.propTypes = propTypes;

export default Switch;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payout-log/components/switch.js